import React from 'react';
import { Link } from 'react-router-dom';

export const Programa = ({ img }) => {
  {
    /**Programa del evento */
  }
  return (
    <div className='product-area section-bottom-padding bg-white'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='section-title-wrapper'>
              <div className='section-title'>
                <ul>
                  <li>
                    <Link to='/programa'>
                      {' '}
                      <h3>Programa</h3>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <img src={`${img}`} />
          </div>
        </div>
      </div>
    </div>
  );
};
